<template>
  <v-form ref="mainForm" v-model="valid">
    <CatalogueLive
      code="exp_ouinon"
      v-model="sas.sasEquivalence.desireAjouterExperienceDeTravail"
      :live="{ endpoint: 'sas-equivalence', cle: '6144', fileId: sas.sasEquivalence.id }"
    />
    <data-iterator
      :list="sas.sasExperienceProfessionnelles"
      add-new-text="Ajouter une experience de travail"
      :live="{ endpoint: 'sas-experiences-professionnelles', sasId: sas.id }"
      :icon="$getIcon('expPro')"
      :valids="valids"
      ref="dataIterator"
      :opqIf="estOui(sas.sasEquivalence.desireAjouterExperienceDeTravail)"
    >
      <template v-slot:show-mode="{ item }">
        <p class="mb-0">{{ item.titreDuPosteOccupe }}</p>
      </template>
      <template v-slot:edit-mode="{ item }">
        <CatalogueLive code="exp_type" v-model="item.typeDExperience" :live="liveSasExperiencePro(6602, item)" />
        <TextFieldLive code="exp_titre" v-model="item.titreDuPosteOccupe" :live="liveSasExperiencePro(6603, item)" />
        <MemoLive code="exp_description" v-model="item.descriptionDesResponsabilites" :live="liveSasExperiencePro(6604, item)" />
        <DatePickerLive code="exp_debut" v-model="item.dateDeDebut" :live="liveSasExperiencePro(6605, item)" />
        <DatePickerLive code="exp_fin" v-model="item.dateDeFin" :live="liveSasExperiencePro(6606, item)" />
        <NumberLive code="exp_heures" v-model="item.nombreDHeuresParSemaine" :live="liveSasExperiencePro(6607, item)" />
        <CatalogueLive code="exp_pays" v-model="item.pays" :live="liveSasExperiencePro(6608, item)" />
        <FileInput code="exp_preuve" :file="item.preuve" :live="liveSasExperiencePro(6609, item)" />
      </template>
    </data-iterator>
  </v-form>
</template>
<script>
import StepFormWithValidation from "@/mixins/StepFormWithValidation"
import CataloguesHelpers from "@/components/ui/mixins/CataloguesHelpers"
export default {
  mixins: [StepFormWithValidation, CataloguesHelpers],
  props: {
    sas: { type: Object }
  },
  methods: {
    liveSasExperiencePro(cle, item) {
      return { endpoint: "sas-experiences-professionnelles", cle: cle, fileId: item.id }
    }
  }
}
</script>

<style>
</style>